import { render, staticRenderFns } from "./RUG.vue?vue&type=template&id=5068f7cf"
import script from "./RUG.vue?vue&type=script&lang=js"
export * from "./RUG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5068f7cf')) {
      api.createRecord('5068f7cf', component.options)
    } else {
      api.reload('5068f7cf', component.options)
    }
    module.hot.accept("./RUG.vue?vue&type=template&id=5068f7cf", function () {
      api.rerender('5068f7cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/RUG.vue"
export default component.exports